import { useQuery } from 'react-query';

import { useAuth0 } from '@auth0/auth0-react';
import setToken from '../../utils/api';
import { IApiResponse } from '../../types/IApiResponse';

export default function useOrderDetails(id: number | undefined) {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<IApiResponse<any>, IApiResponse<any>, any>(
    ['order-details', id],
    async () => {
      const token = await getAccessTokenSilently();
      const api = await setToken(token);
      const response = await api.get<IApiResponse<any>>(`api/orders/${id}`, {});

      if (response?.status !== 200) {
        throw new Error(`Couldn't find order`);
      }

      return response.data;
    },
    {
      enabled: !!id,
      // A refetch resets the Admin form and the lots draft, so only refetch on purpose.
      refetchOnWindowFocus: false,
    },
  );
}
